<template>
  <div class="pad30-lr seller-style min-height">
    <div class="f20 fb gray3 pad20-tb border-b mar20-b">售后订单</div>
    <el-tabs class="f16" v-model="tabsactive" @tab-click="tabClick">
      <el-tab-pane name="all">
        <span slot="label" class="f16 fb">
          全部
          <!-- <template v-if="statusCount[0]">({{ statusCount[0] }})</template> -->
        </span>
      </el-tab-pane>
      <el-tab-pane name="0">
        <span slot="label" class="f16 fb">
          待处理<template v-if="statusCount[1]">({{ statusCount[1] }})</template>
        </span>
      </el-tab-pane>
      <el-tab-pane name="2">
        <span slot="label" class="f16 fb">
          已驳回<template v-if="statusCount[2]">({{ statusCount[2] }})</template>
        </span>
      </el-tab-pane>
      <el-tab-pane name="1">
        <span slot="label" class="f16 fb">
          已通过<template v-if="statusCount[3]">({{ statusCount[3] }})</template>
        </span>
      </el-tab-pane>
    </el-tabs>
    <div class="red mar20-b" v-if="tabsactive == 'all' && orderPendingNum">
      请及时查看【待处理】的售后订单，其中 {{ orderPendingNum }} 笔有可能会自动退款给用户
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="申请日期">
        <el-date-picker
          popper-class="seller-style"
          v-model="formInline.dateTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="订单编号">
        <el-input v-model="formInline.orderId" placeholder="请输入订单编号"></el-input>
      </el-form-item>
      <el-form-item label="售后单号">
        <el-input v-model="formInline.refundOrderId" placeholder="请输入售后单号"></el-input>
      </el-form-item>
      <el-form-item label="退款原因">
        <el-select popper-class="seller-style" v-model="formInline.refundReason" placeholder="请选择">
          <el-option v-for="item in refundReasonList" :key="item.code" :label="item.value" :value="item.code"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="买家信息">
        <el-input v-model="formInline.searchText" placeholder="请输入买家姓名或电话"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="rest">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="tableData" border style="width: 100%">
      <el-table-column fixed prop="refundOrderId" label="售后单号"> </el-table-column>
      <el-table-column prop="orderId" label="订单编号"> </el-table-column>
      <el-table-column prop="refundGoodsQuantity" label="售后商品数量"> </el-table-column>
      <el-table-column prop="orderAmount" label="订单金额"> </el-table-column>
      <el-table-column prop="payAmount" label="实付金额"> </el-table-column>
      <el-table-column prop="refundAmount" label="退款金额"> </el-table-column>
      <el-table-column label="买家信息" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.buyerName }}</span>
          <span class="pad10-l">{{ scope.row.buyerMobile }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请人" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.applyName }}</span>
          <span class="pad10-l">{{ scope.row.applyPhone }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="applyTime" label="申请时间"> </el-table-column>
      <el-table-column prop="refundReasonCn" label="退款原因"> </el-table-column>
      <el-table-column prop="refundStatusCn" label="售后状态"> </el-table-column>
      <el-table-column prop="finishTime" label="退款/驳回时间"> </el-table-column>
      <el-table-column v-if="selfOperatedShop" label="关联采购单号">
        <template slot-scope="scope">
          <span v-for="suppOrderId in scope.row.suppOrderIdList" :key="suppOrderId"
            ><a target="_blank" style="color: #1890ff" :href="`${origin.VUE_APP_APP}v/order/detail/${suppOrderId}`">{{ suppOrderId }}</a></span
          >
        </template>
      </el-table-column>
      <el-table-column v-if="selfOperatedShop" prop="suppShopName" label="供应商店铺"> </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button v-if="scope.row.refundStatus == '0'" @click="reapply(scope.row)" type="text" size="small"> 同意 </el-button>
          <el-button v-if="scope.row.refundStatus == '5'" @click="reback(scope.row)" type="text" size="small"> 退款 </el-button>
          <el-button v-if="scope.row.refundStatus == '0'" @click="revoke(scope.row)" type="text" size="small"> 驳回 </el-button>
          <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="text-right mar20-tb">
      <el-pagination background layout="prev, pager, next" :total="total" @current-change="currentChange" />
    </div>
    <el-dialog title="驳回退款申请" :visible.sync="dialogVisible" width="30%">
      <div class="fb f16 gray3 pad10_tb">驳回原因</div>
      <div>
        <el-input type="textarea" placeholder="请填写您的驳回原因" v-model="firstTrialDesc" maxlength="200" show-word-limit> </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="同意退款" :visible.sync="reapplyShow" width="30%">
      <!--      <div class="fb f16 gray3 pad10_tb">驳回原因</div>-->
      <div class="pad20-tb">
        <div class="flex items-center justify-between mar20-t">
          <div>退款类型</div>
          <div>
            <el-radio-group v-model="reIsPllowPartialRefund">
              <el-radio label="0">全部退款</el-radio>
              <el-radio label="1" v-if="reapplyData.isSupportPartialRefund">部分退款</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="flex items-center justify-between mar20-t">
          <div>退款金额</div>
          <div class="relative">
            <el-input v-if="reIsPllowPartialRefund == 1" placeholder="请输入金额" v-model="reRealAmount"> </el-input>
            <span v-else>{{ reapplyData.payAmount }}元</span>
            <div class="c-primary absolute" v-if="allStatus">退款金额不能大于申请总额</div>
          </div>
        </div>
        <div class="mar20-t">
          <div>退款说明</div>
          <el-input type="textarea" placeholder="请填写您的退款说明" v-model="reFirstTrialDesc" maxlength="200" show-word-limit> </el-input>
        </div>
        <!--        <div>-->
        <!--<div class="white radius20 w100-full h72 bg-primary text-center mar20-t" @click="submit">确定</div>-->
        <!--<div class="white radius20 w100-full h72 bg-primary text-center mar20-t" @click="popup.close()">
        返回</div>-->
        <!--        </div>-->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reapplyShow = false">取 消</el-button>
        <el-button type="primary" @click="agreeRefundSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/requestApi";
import requestSC from "@/utils/requestSC";

export default {
  data() {
    return {
      origin: process.env,
      total: 0,
      allStatus: "",
      partStatus: "",
      loading: false,
      tableData: [],
      statusCount: [],
      formInline: {
        orderId: "",
        refundOrderId: "",
        shopName: "",
        userinfo: "",
        dateTime: [],
        searchText: "",
        refundReason: "",
      },
      tabsactive: "all",
      pageSize: 10,
      pageNum: 1,
      searchVal: "",
      dialogVisible: false,
      reapplyShow: false,
      textarea: "",
      refundOrderId: "",
      firstTrialDesc: "",
      reRealAmount: "",
      reFirstTrialDesc: "",
      reIsPllowPartialRefund: "0",
      orderPendingNum: "",
      reapplyData: {},
      refundReasonList: [],
      selfOperatedShop: false, // 是否直营
    };
  },
  created() {
    this.getData();
    this.getStatusMarkersCount();
    requestSC.get("rest/mj/goods/seq/shopConfig").then((res) => {
      this.selfOperatedShop = res.data.selfOperatedShop;
    });
    request
      .post("scbasic/dataDictionary/selDataDictionaryItemList", {
        dictId: "REFUND_CASE",
      })
      .then((res) => {
        this.refundReasonList = res.data;
      });
  },
  watch: {
    dialogVisible: function (val) {
      if (!val) {
        this.firstTrialDesc = "";
      }
    },
    reapplyShow: function (val) {
      if (!val) {
        this.reIsPllowPartialRefund = "0";
        this.reFirstTrialDesc = "";
      }
    },
  },
  methods: {
    getData() {
      console.log("this.formInline.searchVal", this.formInline);
      this.loading = true;
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        terminalType: 1,
        searchText: this.formInline.searchText,
        orderId: this.formInline.orderId,
        refundOrderId: this.formInline.refundOrderId,
        refundStatus: this.tabsactive == "all" ? "" : this.tabsactive,
        createTimeStartStr: this.formInline.dateTime[0],
        createTimeEndStr: this.formInline.dateTime[1],
        refundReason: this.formInline.refundReason,
      };
      this.$store.dispatch("aftersales/sellerPage", params).then((res) => {
        if (res.code === "0") {
          this.total = res.data.total;
          console.log("res.data.list", res.data.list);
          this.tableData = res.data.list;
          if (this.tabsactive == "all" && res.data.list) {
            this.orderPendingNum = (res.data.list[0] && res.data.list[0].automaticRefundQuantity) || 0;
          }
        }
        this.loading = false;
      });
    },
    currentChange(page) {
      this.pageNum = page;
      this.getData();
    },
    getStatusMarkersCount() {
      this.$store.dispatch("aftersales/getStatusMarkersCount", { isSeller: 1 }).then((res) => {
        console.log(res);
        if (res.code === "0" && res.data) {
          this.statusCount = [
            Number(res.data.applyingCount) + Number(res.data.passedCount) + Number(res.data.rejectedCount),
            res.data.applyingCount,
            res.data.rejectedCount,
            res.data.passedCount,
          ];
        }
      });
    },
    tabClick() {
      this.pageNum = 1;
      this.getData();
      this.getStatusMarkersCount();
    },
    handleClick(row) {
      this.$router.push(`/aftersales/detail/${row.refundOrderId}?orderId=${row.orderId}`);
      console.log(row);
    },
    onSubmit() {
      this.getData();
      console.log("submit!");
    },
    rest() {
      Object.keys(this.formInline).forEach((key) => {
        this.formInline[key] = "";
      });
      this.pageSize = 10;
      this.getData();
    },
    revoke(row) {
      this.dialogVisible = true;
      this.refundOrderId = row.refundOrderId;
      console.log(row);
    },
    reapply(item) {
      console.log("item", item);
      this.$confirm("是否同意买家的退款申请？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store
          .dispatch("aftersales/agreeRefund", {
            refundOrderId: item.refundOrderId,
          })
          .then((res) => {
            if (res.code === "0") {
              this.pageNum = 1;
              this.reapplyShow = false;
              this.getData();
              this.getStatusMarkersCount();
              this.$message.success(res.data ? res.data : res.msg);
            }
          });
      });
    },
    reback(item) {
      console.log("item", item);
      this.reapplyData = item;
      this.reapplyShow = true;
    },
    submit() {
      this.$store.dispatch("aftersales/rejectRefund", { refundOrderId: this.refundOrderId, firstTrialDesc: this.firstTrialDesc }).then((res) => {
        if (res.code === "0") {
          this.dialogVisible = false;
          this.pageNum = 1;
          this.getData();
          this.getStatusMarkersCount();
          this.$message.success(res.data ? res.data : res.msg);
        }
      });
    },
    agreeRefundSubmit() {
      const { reapplyData, reRealAmount } = this;
      if (!Number.isFinite(Number(reRealAmount))) {
        this.$message.error("退款金额不对");
        return;
      }

      if (Number(reRealAmount) > reapplyData.payAmount) {
        this.$message.error("退款金额不能大于申请总额");
        return;
      }

      if (this.reIsPllowPartialRefund == "1" && Number(reRealAmount) >= reapplyData.payAmount) {
        this.$message.error("退款金额不能大于等于申请总额");
        return;
      }

      console.log("this.reIsPllowPartialRefund", this.reIsPllowPartialRefund);

      this.$store
        .dispatch("aftersales/backRefund", {
          refundOrderId: this.reapplyData.refundOrderId,
          isPllowPartialRefund: this.reIsPllowPartialRefund,
          realAmount: this.reIsPllowPartialRefund != "1" ? this.reapplyData.payAmount : this.reRealAmount,
          firstTrialDesc: this.reFirstTrialDesc,
        })
        .then((res) => {
          if (res.code === "0") {
            this.pageNum = 1;
            this.reapplyShow = false;
            this.getData();
            this.getStatusMarkersCount();
            this.$message.success(res.data ? res.data : res.msg);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
